const { useState, useEffect } = React
const { CheckBox } = Pledge.components

const Newsletter = ({ donation, data, setDataDefaults }) => {
  const sharingEnabled = donation.shares.length > 0
  const [ intendedChecked, setIntendedChecked ] = useState(false)

  useEffect(() => {
    setDataDefaults({ newsletter: false })
  }, [])

  useEffect(() => {
    data.set('newsletter', sharingEnabled ? intendedChecked : false)
  }, [ sharingEnabled, intendedChecked ])

  const updateNewsletter = e => {
    const checked = e.target.checked
    setIntendedChecked(checked)
    data.set('newsletter', checked)
  }

  return (
    <CheckBox
      id="newsletter"
      label="I would like to receive updates from CORE, including news, events,
        stories from the field, emergency response updates, and opportunities
        to get involved in my local community."
      checked={sharingEnabled && data.get('newsletter', false)}
      disabled={!sharingEnabled}
      onChange={updateNewsletter}
    />
  )
}

const plugin = {
  version: 6,
  hooks: { afterDataSharing: Newsletter },
  collectData: 'only:fiat,crypto,wire_check',
}

Pledge.widget.addPlugin(plugin)
